import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { TagsInfoType } from "../../helpers/resourceHelper";
import { useOperation } from "../../hooks/useOperation";
import { OperationProps } from "../OperationTypes";
import { newVmDbUpdateTagsPdb, VmDbUpdateTagsPdbProps } from "./VmDbUpdateTagsPdb";

export interface VmDbEditTagsPdbProps extends OperationProps {
  databaseId: string | undefined;
  defaultTags?: TagsInfoType;
}

const VmDbEditTagsPdb = (
  { location, databaseId, defaultTags, onExecute, onCancel }: VmDbEditTagsPdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsPdb } = useOperation<VmDbUpdateTagsPdbProps>(newVmDbUpdateTagsPdb);

  return (
    <TagsEditPanel
      title={Messages.labels.editTags()}
      resourceId={databaseId}
      tagsDefaultValue={defaultTags}
      onSubmit={(formValues: FormValues) => {
        const tags = getValue<TagsInfoType>(formValues, TagDetailsFields.Tags, InputFormGroup) ?? [];
        triggerUpdateTagsPdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newVmDbEditTagsPdb = (
  props: VmDbEditTagsPdbProps,
): JSX.Element => (<VmDbEditTagsPdb {...props} />);
